export default __webpack_public_path__ + "static/media/carousel1.adb2aaf4.jpg";